export default __webpack_public_path__ + "static/media/Mensagem-banner.45fa3073.png";